import React from 'react';
import { useApp } from '../context/AppContext';
import Icon from './Icon';
import './Toasts.css';

const ICONS = {
  success: 'check',
  error: 'close',
  info: 'sparkle',
};

export default function Toasts() {
  const { toasts } = useApp();
  return (
    <div className="nx-toasts" aria-live="polite">
      {toasts.map((t) => (
        <div key={t.id} className={`nx-toast nx-toast--${t.kind}`}>
          <span className="nx-toast__icon">
            <Icon name={ICONS[t.kind] || 'sparkle'} size={14} />
          </span>
          <span className="nx-toast__msg">{t.msg}</span>
          <span className="nx-toast__bar" />
        </div>
      ))}
    </div>
  );
}
